import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { spaceOptions } from './utils';
import SuccessIcon from './images/icons/success.svg';
import NoticeIcon from './images/icons/notice.svg';
import ErrorIcon from './images/icons/error.svg';
import { transparentize, desaturate } from 'polished';

const Types = ['success', 'notice', 'error'];
const Icons = {
  success: SuccessIcon,
  notice: NoticeIcon,
  error: ErrorIcon
};

const getColorFromProps = props => {
  return (
    props.theme[Types.find(type => Object.keys(props).indexOf(type) > -1)] || props.theme.success
  );
};

const getSvgFromProps = props => {
  return Icons[Types.find(type => Object.keys(props).indexOf(type) > -1)] || Icons.success;
};

const AlertWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-radius: 5px;
  color: ${props =>
    desaturate(0.4, getColorFromProps(props)) || desaturate(0.4, props.theme.success)};
  border: 1px solid
    ${props =>
      transparentize(0.7, getColorFromProps(props)) || transparentize(0.7, props.theme.success)};
  background-color: ${props =>
    transparentize(0.95, getColorFromProps(props)) || transparentize(0.95, props.theme.success)};
  ${spaceOptions};
  &::before {
    content: url(${props => getSvgFromProps(props) || SuccessIcon});
    width: 25px;
    height: 25px;
    margin-right: 15px;
  }
`;

export const Alert = ({ children, ...rest }) => (
  <AlertWrapper {...rest}>
    <div>{children}</div>
  </AlertWrapper>
);

Alert.propTypes = {
  children: PropTypes.node
};

Alert.displayName = 'Alert';
